import { render, staticRenderFns } from "./QuestionsInfo.vue?vue&type=template&id=41163907&scoped=true"
import script from "./QuestionsInfo.vue?vue&type=script&lang=js"
export * from "./QuestionsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41163907",
  null
  
)

export default component.exports